export default {
	PATH_PARAMS: 'pathParams',
	AUTH: 'auth',
	CHANGE_PASSWORD: 'changePassword',
	ROUTE_LINK: 'routeLink',
	API_ROOT: 'http://141.95.6.204:1337',
};
